import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  G4_P4_S1_Name: {
    id: `guide04.page04.slide01.name`,
  },
  G4_P4_S2_Name: {
    id: `guide04.page04.slide02.name`,
  },
  G4_P4_S3_Name: {
    id: `guide04.page04.slide03.name`,
  },
  G4_P4_S4_Name: {
    id: `guide04.page04.slide04.name`,
  },
  G4_P4_S5_Name: {
    id: `guide04.page04.slide05.name`,
  },

  G4_P4_S1_Title: {
    id: `guide04.page04.slide01.title`,
  },
  G4_P4_S1_Description: {
    id: `guide04.page04.slide01.description`,
  },
  G4_P4_S1_Item1: {
    id: `guide04.page04.slide01.item1`,
  },
  G4_P4_S1_Item2: {
    id: `guide04.page04.slide01.item2`,
  },
  G4_P4_S1_Item3: {
    id: `guide04.page04.slide01.item3`,
  },
  G4_P4_S1_Item4: {
    id: `guide04.page04.slide01.item4`,
  },
  G4_P4_S1_Item5: {
    id: `guide04.page04.slide01.item5`,
  },

  G4_P4_S2_Title1: {
    id: `guide04.page04.slide02.title1`,
  },
  G4_P4_S2_Item1: {
    id: `guide04.page04.slide02.item1`,
  },
  G4_P4_S2_Item2: {
    id: `guide04.page04.slide02.item2`,
  },
  G4_P4_S2_Title2: {
    id: `guide04.page04.slide02.title2`,
  },
  G4_P4_S2_Item3: {
    id: `guide04.page04.slide02.item3`,
  },
  G4_P4_S2_Item4: {
    id: `guide04.page04.slide02.item4`,
  },
  G4_P4_S2_Item5: {
    id: `guide04.page04.slide02.item5`,
  },
  G4_P4_S2_Note: {
    id: `guide04.page04.slide02.note`,
  },

  G4_P4_S3_S1_Title: {
    id: `guide04.page04.slide03.subslide01.title`,
  },
  G4_P4_S3_S1_Description_1: {
    id: `guide04.page04.slide03.subslide01.description1`,
  },
  G4_P4_S3_S1_Description_2: {
    id: `guide04.page04.slide03.subslide01.description2`,
  },
  G4_P4_S3_S2_Title: {
    id: `guide04.page04.slide03.subslide02.title`,
  },
  G4_P4_S3_S2_Description_1: {
    id: `guide04.page04.slide03.subslide02.description1`,
  },
  G4_P4_S3_S2_Description_2: {
    id: `guide04.page04.slide03.subslide02.description2`,
  },
  G4_P4_S3_S2_Description_3: {
    id: `guide04.page04.slide03.subslide02.description3`,
  },
  G4_P4_S3_S2_Description_4: {
    id: `guide04.page04.slide03.subslide02.description4`,
  },

  G4_P4_S3_S3_Title: {
    id: `guide04.page04.slide03.subslide03.title`,
  },
  G4_P4_S3_S3_Subtitle1: {
    id: `guide04.page04.slide03.subslide03.subTitle1`,
  },
  G4_P4_S3_S3_Description_1: {
    id: `guide04.page04.slide03.subslide03.description1`,
  },
  G4_P4_S3_S3_Description_2: {
    id: `guide04.page04.slide03.subslide03.description2`,
  },
  G4_P4_S3_S3_Description_3: {
    id: `guide04.page04.slide03.subslide03.description3`,
  },
  G4_P4_S3_S3_Description_4: {
    id: `guide04.page04.slide03.subslide03.description4`,
  },
  G4_P4_S3_S3_Description_5: {
    id: `guide04.page04.slide03.subslide03.description5`,
  },
  G4_P4_S3_S4_Title: {
    id: `guide04.page04.slide03.subslide04.title`,
  },
  G4_P4_S3_S4_Subtitle1: {
    id: `guide04.page04.slide03.subslide04.subTitle1`,
  },
  G4_P4_S3_S4_Description_1: {
    id: `guide04.page04.slide03.subslide04.description1`,
  },
  G4_P4_S3_S4_Description_2: {
    id: `guide04.page04.slide03.subslide04.description2`,
  },
  G4_P4_S3_S4_Disclaimer: {
    id: `guide04.page04.slide03.subslide04.disclaimer`,
  },
  G4_P4_S3_S5_Title: {
    id: `guide04.page04.slide03.subslide05.title`,
  },
  G4_P4_S3_S5_Subtitle1: {
    id: `guide04.page04.slide03.subslide05.subTitle1`,
  },
  G4_P4_S3_S5_Description_1: {
    id: `guide04.page04.slide03.subslide05.description1`,
  },
  G4_P4_S3_S5_Description_2: {
    id: `guide04.page04.slide03.subslide05.description2`,
  },
  G4_P4_S3_S5_Subtitle2: {
    id: `guide04.page04.slide03.subslide05.subTitle2`,
  },
  G4_P4_S3_S5_Description_3: {
    id: `guide04.page04.slide03.subslide05.description3`,
  },

  //Sound design tab
  G4_P4_S4_S1_Title: {
    id: `guide04.page04.slide04.subslide01.title`,
  },
  G4_P4_S4_S1_Note: {
    id: `guide04.page04.slide04.subslide01.note`,
  },
  G4_P4_S4_S2_Title: {
    id: `guide04.page04.slide04.subslide02.title`,
  },
  G4_P4_S4_S2_Description: {
    id: `guide04.page04.slide04.subslide02.description`,
  },
  G4_P4_S4_S3_Title: {
    id: `guide04.page04.slide04.subslide03.title`,
  },
  G4_P4_S4_S3_Description: {
    id: `guide04.page04.slide04.subslide03.description`,
  },
  G4_P4_S4_S3_Note: {
    id: `guide04.page04.slide04.subslide03.note`,
  },
  G4_P4_S4_S4_Title: {
    id: `guide04.page04.slide04.subslide04.title`,
  },
  G4_P4_S4_S4_Description: {
    id: `guide04.page04.slide04.subslide04.description`,
  },
  G4_P4_S4_S4_Note: {
    id: `guide04.page04.slide04.subslide04.note`,
  },
  G4_P4_S4_S5_Title: {
    id: `guide04.page04.slide04.subslide05.title`,
  },
  G4_P4_S4_S5_Description: {
    id: `guide04.page04.slide04.subslide05.description`,
  },
  G4_P4_S4_S6_Title: {
    id: `guide04.page04.slide04.subslide06.title`,
  },
  G4_P4_S4_S6_Description: {
    id: `guide04.page04.slide04.subslide06.description`,
  },
  G4_P4_S4_S7_Title: {
    id: `guide04.page04.slide04.subslide07.title`,
  },
  G4_P4_S4_S7_Description: {
    id: `guide04.page04.slide04.subslide07.description`,
  },
  G4_P4_S4_S8_Title: {
    id: `guide04.page04.slide04.subslide08.title`,
  },
  G4_P4_S4_S8_Description: {
    id: `guide04.page04.slide04.subslide08.description`,
  },
  G4_P4_S4_S9_Title: {
    id: `guide04.page04.slide04.subslide09.title`,
  },
  G4_P4_S4_S9_Description: {
    id: `guide04.page04.slide04.subslide09.description`,
  },
  G4_P4_S4_S10_Title: {
    id: `guide04.page04.slide04.subslide010.title`,
  },
  G4_P4_S4_S10_Description: {
    id: `guide04.page04.slide04.subslide010.description`,
  },
  //Resoures tab
  G4_P4_S6_G1_Title: {
    id: `guide04.page04.slide06.group1.title`,
  },
  G4_P4_S6_G1_L1_Description: {
    id: `guide04.page04.slide06.group1.link1.description`,
  },
  G4_P4_S6_G1_L1_LinkLabel: {
    id: `guide04.page04.slide06.group1.link1.link_label`,
  },
  G4_P4_S6_G1_L2_Description: {
    id: `guide04.page04.slide06.group1.link2.description`,
  },
  G4_P4_S6_G1_L2_LinkLabel: {
    id: `guide04.page04.slide06.group1.link2.link_label`,
  },
  G4_P4_S6_G1_L3_Description: {
    id: `guide04.page04.slide06.group1.link3.description`,
  },
  G4_P4_S6_G1_L3_LinkLabel: {
    id: `guide04.page04.slide06.group1.link3.link_label`,
  },

  G4_P4_S6_G2_Title: {
    id: `guide04.page04.slide06.group2.title`,
  },
  G4_P4_S6_G2_L1_Description: {
    id: `guide04.page04.slide06.group2.link1.description`,
  },
  G4_P4_S6_G2_L1_LinkLabel: {
    id: `guide04.page04.slide06.group2.link1.link_label`,
  },
  G4_P4_S6_G2_L2_Description: {
    id: `guide04.page04.slide06.group2.link2.description`,
  },
  G4_P4_S6_G2_L2_LinkLabel: {
    id: `guide04.page04.slide06.group2.link2.link_label`,
  },
  G4_P4_S6_G2_L3_Description: {
    id: `guide04.page04.slide06.group2.link3.description`,
  },
  G4_P4_S6_G2_L3_LinkLabel: {
    id: `guide04.page04.slide06.group2.link3.link_label`,
  },

  G4_P4_S6_G3_Title: {
    id: `guide04.page04.slide06.group3.title`,
  },
  G4_P4_S6_G3_L1_Description: {
    id: `guide04.page04.slide06.group3.link1.description`,
  },
  G4_P4_S6_G3_L1_LinkLabel: {
    id: `guide04.page04.slide06.group3.link1.link_label`,
  },
  G4_P4_S6_G3_L2_Description: {
    id: `guide04.page04.slide06.group3.link2.description`,
  },
  G4_P4_S6_G3_L2_LinkLabel: {
    id: `guide04.page04.slide06.group3.link2.link_label`,
  },
  G4_P4_S6_G3_L3_Description: {
    id: `guide04.page04.slide06.group3.link3.description`,
  },
  G4_P4_S6_G3_L3_LinkLabel: {
    id: `guide04.page04.slide06.group3.link3.link_label`,
  },
});
